import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import swal from "sweetalert";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MUIDataTable from "mui-datatables";
import { API_URL } from "../../config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import CircularProgress from "@material-ui/core/CircularProgress";

import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { pathSpliter, checkAuthBranchWare } from "../../lib/functions";
import {
  currentRouteSet,
  createdCustomerSet,
  updatedCustomerSet,
  disableRestoreCustomerSet,
} from "../../actions/actions";

import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

const SupplierContactPersonsManage = ({
  location,
  currentRouteSet,
  authInfo,
  customerCodeAction,
  createdCustomer,
  updatedCustomer,
  customerDisableRestore,
  createdCustomerSet,
  updatedCustomerSet,
  disableRestoreCustomerSet,
  createdArea,
}) => {
  const classes = useStyles();
  let [loadingSave, loadingSaveSet] = useState(false);
  let [loadingList, loadingListSet] = useState(false);
  let [areaM, areaMSet] = useState(false);

  let [customerUpdateIndex, customerUpdateIndexSet] = useState("0");
  let [customer_id, customer_id_set] = useState("0");

  let [customers, customersSet] = useState([]);
  let [areas, areasSet] = useState([]);
  let [employees, employeesSet] = useState([]);
  let [areaAction, areaActionSet] = useState(false);

  let [customer_name, customer_name_set] = useState("");

  let [customer_address, customer_address_set] = useState("");
  let [customer_mobile_no, customer_mobile_no_set] = useState("");
  let [customer_phone_no, customer_phone_no_set] = useState("");
  let [customer_email, customer_email_set] = useState("");

  let [action, action_set] = useState("create");

  let [selectedArea, selectedAreaSet] = useState(null);
  let [selectedEmployee, selectedEmployeeSet] = useState(null);

  let customerNameRef = React.useRef(null);

  let customerAddressRef = React.useRef(null);

  let customerMobileRef = React.useRef(null);
  let customerPhoneRef = React.useRef(null);
  let customerEmailRef = React.useRef(null)
  let customerActionRef = React.useRef(null);

  const [successMsg, setSuccessMsg] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    msg: "",
  });

  const { vertical, horizontal, open, msg } = successMsg;
  const handleClose = () => {
    setSuccessMsg({ ...successMsg, open: false });
  };

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));

    getCustomers();

    getEmployees();
  }, []);

  const getEmployees = async () => {
    loadingListSet(true);
    await axios
      .post(`${API_URL}/api/get-suppliers`, null, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        loadingListSet(false);
        employeesSet(res.data.message);
      });
  };
  const getCustomers = async () => {
    loadingListSet(true);
    await axios
      .post(`${API_URL}/api/get-suppliers-contact`, null, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        loadingListSet(false);
        customersSet(res.data.message);
      });
  };

  // Customer  Real time start
  // useEffect(() => {
  //   if (createdCustomer) {
  //     if (checkAuthBranchWare(createdCustomer.user_branch_id)) {
  //       customersSet(createdCustomer.createdRow.concat(customers));
  //       setSuccessMsg({
  //         ...successMsg,
  //         msg: `${createdCustomer.msg}`,
  //         open: true,
  //       });
  //     }
  //   }
  // }, [createdCustomer]);

  // useEffect(() => {
  //   if (updatedCustomer) {
  //     if (checkAuthBranchWare(updatedCustomer.user_branch_id)) {
  //       customers[updatedCustomer.index] = updatedCustomer.updatedRow[0];
  //       setSuccessMsg({
  //         ...successMsg,
  //         msg: `${updatedCustomer.msg}`,
  //         open: true,
  //       });
  //     }
  //   }
  // }, [updatedCustomer]);

  // useEffect(() => {
  //   if (customerDisableRestore) {
  //     if (checkAuthBranchWare(customerDisableRestore.user_branch_id)) {
  //       customers[customerDisableRestore.index] =
  //         customerDisableRestore.disableRestoreRow[0];
  //       setSuccessMsg({
  //         ...successMsg,
  //         msg: `${customerDisableRestore.msg}`,
  //         open: true,
  //       });
  //     }
  //   }
  // }, [customerDisableRestore]);

  // useEffect(() => {
  //   if (createdArea) {
  //     if (checkAuthBranchWare(createdArea.user_branch_id)) {
  //       areasSet(createdArea.createdRow.concat(areas));
  //     }
  //   }
  // }, [createdArea]);

  // createdCustomerSet(null);
  // updatedCustomerSet(null);
  // disableRestoreCustomerSet(null);

  const saveFormAction = async () => {
    if (customer_name.trim() == "") {
      swal({
        title: "Name is required.",
        icon: "warning",
      });
      return
    }
    if (customer_address.trim() == "") {
      swal({
        title: "Address is required.",
        icon: "warning",
      });
      return
    }
    if (customer_mobile_no.trim() == "") {
      swal({
        title: "Mobile number is required.",
        icon: "warning",
      });
      return
    }
    if (customer_phone_no.trim() == "") {
      swal({
        title: "Phone number is required.",
        icon: "warning",
      });
      return
    }
    if (customer_email.trim() == "") {
      swal({
        title: "Email is required.",
        icon: "warning",
      });
      return
    }
    if (selectedEmployee == null) {
      swal({
        title: "Supplier is required.",
        icon: "warning",
      });
      return
    }
    else {
      let payLoad = {
        customer_name,
        customer_address,
        customer_mobile_no,
        customer_phone_no,
        customer_email,
        employee_id:
          selectedEmployee != null ? selectedEmployee.supplier_id : null,
        action,
        customerUpdateIndex,
        customer_id,
      };

      loadingSaveSet(true);
      await axios
        .post(`${API_URL}/api/supplier-contact-person-cu`, payLoad, {
          headers: { "auth-token": authInfo.token },
        })
        .then((res) => {
          loadingSaveSet(false);

          if (res.data.error) {
            swal({
              title: `${res.data.message}`,
              icon: "warning",
            });
            return false;
          } else {
            swal({
              title: `${res.data.message}`,
              icon: "success",
            });
          }
          getCustomers()
          selectedAreaSet(null);
          customer_name_set("");
          customer_mobile_no_set("");
          customer_address_set("");
          customer_mobile_no_set("");
          customer_phone_no_set("");
          customer_email_set("");
          action_set("create");
          selectedEmployeeSet(null);
        }).catch(e => {
          loadingSaveSet(false)
          swal({
            title: `Failed to ${action} contact person`,
            icon: "warning",
          });
        });
    }
  };

  const customerEdit = (row, index) => {
    let customer = customers[index];
    customer_name_set(customer.contact_person_name);

    customer_address_set(customer.contact_person_address);
    customer_mobile_no_set(customer.contact_person_mobile_no);
    customer_phone_no_set(customer.contact_person_phone_no);
    customer_email_set(customer.contact_person_email)

    selectedEmployeeSet(employees.find(e => e.customer_id === customer.customer_id));

    action_set("update");
    customer_id_set(customer.contact_person_id);

    customerUpdateIndexSet(index);
  };
  const contactPersonDisableRestore = async (customerId, actionCond, index) => {
    await axios.post(
      `${API_URL}/api/supplier-contact-person-disable-restore`,
      { contact_person_id: customerId, action: actionCond, index },
      { headers: { "auth-token": authInfo.token } }
    ).then(res => {
      getCustomers()
      swal({
        title: `${res.data.message}`,
        icon: "success"
      }).catch(err => {
        swal({
          title: `Could not ${actionCond} contact person`,
          icon: "warning"
        })
      });
    });
  };

  const ActionOptions = (props) => {
    return (
      <div style={{ textAlign: "right" }}>
        {authInfo.role != "user" ? (
          <>
            <EditIcon
              style={{
                cursor: "pointer",
                fontSize: "28px",
                color: "rgb(15, 126, 119)",
              }}
              onClick={() => customerEdit(props.rowData, props.rowIndex)}
            />
            {props.rowData[9] == "active" ? (
              <DeleteIcon
                style={{
                  cursor: "pointer",
                  color: "#ff0202",
                  fontSize: "28px",
                }}
                onClick={() =>
                  contactPersonDisableRestore(
                    props.rowData[0],
                    "disable",
                    props.rowIndex
                  )
                }
              />
            ) : (
              <SettingsBackupRestoreIcon
                style={{
                  cursor: "pointer",
                  color: "rgb(60, 178, 194)",
                  fontSize: "28px",
                }}
                onClick={() =>
                  contactPersonDisableRestore(
                    props.rowData[0],
                    "restore",
                    props.rowIndex
                  )
                }
              />
            )}
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  const columns = [
    { name: "contact_person_id", options: { display: "excluded" } },
    { name: "customer_status", options: { display: "excluded" } },
    {
      name: "SL",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return <p>{parseFloat(tableMeta.rowIndex) + 1}</p>;
        },
      },
      headerStyle: {
        textAlign: "left",
      },
    },

    {
      name: "contact_person_name",
      label: "Contact Person",
      options: { filter: true, sort: true },
    },
    {
      name: "contact_person_address",
      label: "address",
      options: { filter: true, sort: true },
    },
    {
      name: "supplier_name",
      label: "Supplier name",
      options: { filter: true, sort: true },
    },
    {
      name: "contact_person_mobile_no",
      label: "Mobile no",
      options: { filter: true, sort: true },
    },
    {
      name: "contact_person_email",
      label: "Email",
      options: { filter: true, sort: true },
    },
    {
      name: "contact_person_phone_no",
      label: "Phone no",
      options: { filter: true, sort: true },
    },
    {
      name: "contact_person_status",
      options: { display: "excluded" },
    },

    {
      name: "actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <ActionOptions
              value={value}
              rowIndex={tableMeta.rowIndex}
              rowData={tableMeta.rowData}
            />
          );
        },
      },
      headerStyle: {
        textAlign: "right",
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    display: "excluded",
  };
  return (
    <div className={classes.root}>
      {/* Success message */}
      <Snackbar open={open} autoHideDuration={10000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          {successMsg.msg}
        </Alert>
      </Snackbar>
      {/* End of message */}
      <Paper className={classes.paper} style={{ marginTop: "-15px" }}>
        <h2 className={classes.pageEntryLabel}>
          {" "}
          Supplier Contact Person Entry
        </h2>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={customer_name}
              label="Contact Person Name"
              name="customer_name"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={(e) => customer_name_set(e.target.value)}
              inputRef={customerNameRef}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  customerAddressRef.current?.focus();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={customer_address}
              label="Contact Person Address"
              name="customer_address"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={(e) => customer_address_set(e.target.value)}
              inputRef={customerAddressRef}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  customerMobileRef.current?.focus();
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={3} className={classes.plusLinkDiv}>
            <Autocomplete
              style={{ width: "100%" }}
              options={employees}
              size="small"
              openOnFocus={true}
              getOptionLabel={(option) => option.supplier_name}
              value={selectedEmployee}
              onKeyDown={(event) => {
                if (event.key === "Enter") setTimeout(() => customerMobileRef.current?.focus(), 0);
              }}
              onChange={(event, selectedObj) => {
                selectedEmployeeSet(selectedObj);
                setTimeout(() => customerMobileRef.current?.focus(), 0);
              }}
              loading={employees.length == 0 ? true : false}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose a Supplier"
                  variant="outlined"
                  inputProps={{
                    ...params.inputProps,
                    endAdornment: (
                      <React.Fragment>
                        {/* {areas.length==0 ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment} */}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={customer_mobile_no}
              label="Mobile Number"
              name="customer_mobile_no"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,11}$/.test(value)) {
                  // Ensures only up to 11 digits are allowed
                  customer_mobile_no_set(value);
                }
              }}
              inputRef={customerMobileRef}
              error={
                customer_mobile_no.length > 0 &&
                customer_mobile_no.length !== 11
              }
              helperText={
                customer_mobile_no.length > 0 &&
                  customer_mobile_no.length !== 11
                  ? "Mobile number must be 11 digits"
                  : ""
              }
              onKeyDown={(event) => {
                if (event.key === "Enter" && customer_mobile_no.length === 11) {
                  customerPhoneRef.current.focus();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={customer_phone_no}
              label="Phone Number"
              name="customer_phone_no"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={(e) => customer_phone_no_set(e.target.value)}
              inputRef={customerPhoneRef}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  customerEmailRef.current?.focus();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={customer_email}
              label="Email"
              name="customer_email"
              type="email"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={(e) => customer_email_set(e.target.value)}
              inputRef={customerEmailRef}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  customerActionRef.current?.click();
                }
              }}
            />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Button
            style={{ marginTop: "25px" }}
            variant="contained"
            color="primary"
            size="small"
            buttonRef={customerActionRef}
            className={classes.button}
            startIcon={<SaveIcon />}
            disabled={loadingSave}
            onClick={saveFormAction}
          >
            Save
          </Button>
        </Grid>
      </Paper>
      {loadingList == true ? (
        <b>Loading...</b>
      ) : (
        <Paper className={classes.paper} style={{ marginTop: "20px" }}>
          <MUIDataTable
            title={"Supplier Contact Person List"}
            data={customers}
            columns={columns}
            options={options}
            adjustForCheckbox={false}
            displaySelectAll={false}
          />
        </Paper>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  root: {},
  "& .MuiTextField-root": {
    margin: theme.spacing(1),
    width: "25ch",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  pageEntryLabel: {
    color: "#7754cc",
    margin: "0px",
    padding: "0px",
    marginTop: "-11px",
    textAlign: "left",
    marginLeft: "0px",
    marginBottom: "5px",
    textAlign: "left",
  },
  fullWidth: {
    width: "100%",
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
    // customerCode: state.customerCodeReducer,
    // createdCustomer: state.createdCustomerReducer,
    // updatedCustomer: state.updatedCustomerReducer,
    // customerDisableRestore: state.customerDisableRestoreReducer,
    // createdArea: state.createdAreaReducer,
  };
};
export default connect(mapStateToPops, {
  currentRouteSet,
  // createdCustomerSet,
  // updatedCustomerSet,
  // disableRestoreCustomerSet,
})(SupplierContactPersonsManage);
